<template>
    <b-form-group>
        <div>
            <b-button variant="link" @click="addNewQuestion">
                {{ $t('form.button.enterAQuestion') }}
            </b-button>
            <div v-for="(question, index) in questions" :key="index">
                <b-form-group>
                    <b-input-group class="mt-1" size="sm">
                        <b-form-textarea
                            :placeholder="$t('form.button.enterAQuestion')"
                            v-model="question.title"
                            :disabled="question.clicked"
                            @change="updateValue(index)"
                            :aria-describedby="`input-asking-${index}`"
                            :state="checkState(question, index)"
                        />
                        <b-input-group-append>
                            <b-button
                                variant="outline-primary"
                                @click="checkQuestion(index)"
                                :disabled="!question.title.length"
                            >
                                <i
                                    :class="{
                                        'fa fa-check': !question.clicked,
                                        'fa fa-edit': question.clicked,
                                    }"
                                ></i>
                            </b-button>
                            <b-button
                                variant="outline-danger"
                                @click="removeQuestion(index)"
                            >
                                <i class="fa fa-times"></i>
                            </b-button>
                        </b-input-group-append>
                        <b-form-invalid-feedback :id="`input-asking-${index}`">
                            <span
                                v-if="
                                    question.dirty &&
                                        validation.$each[index].$invalid
                                "
                            >
                                {{ $t('form.validations.required') }}
                            </span>
                        </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </div>
        </div>
    </b-form-group>
</template>

<script>
export default {
    name: 'InputQuestion',
    props: ['askings', 'validation'],
    data() {
        return {
            questions: [],
        }
    },
    methods: {
        checkQuestion(index) {
            this.questions[index].clicked = !this.questions[index].clicked
        },

        addNewQuestion() {
            let newQuestion = {
                id: null,
                title: '',
                clicked: false,
                dirty: false,
            }
            this.questions.push(newQuestion)
        },

        removeQuestion(index) {
            this.questions.splice(index, 1)
        },

        updateValue(index) {
            this.questions[index].id = null
            this.questions[index].dirty = true
        },
        checkState(question, index) {
            const field = this.validation.$each[index]
            return question.dirty ? !field.$invalid : null
        },
    },
    watch: {
        questions(value) {
            this.$emit('changeAskings', value)
        },
        askings(values) {
            const newValue = values.map(value => ({
                ...value,
                clicked: true,
                dirty: false,
            }))
            this.questions = newValue
        },
    },
}
</script>
